module.exports = __webpack_public_path__ + "static-portal/img/xqhz.1bca883.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/xqhz.jpg
// module id = tbrx
// module chunks = 4